import { useToast } from '@ui';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useInstall } from './install';
import { useAppBadge } from './useAppBadge';
import { useUpdateAvailable } from './useUpdateNotice';

/** Quiet hints about the app itself: install once, reload after an update. */
export function PwaNotices() {
  const { t } = useTranslation();
  const toast = useToast();
  const install = useInstall();
  const updateAvailable = useUpdateAvailable();
  useAppBadge();
  const hinted = useRef(false);
  const updateShown = useRef(false);

  const { kind, dismissed, dismiss } = install;
  useEffect(() => {
    if (hinted.current || dismissed) return;
    if (install.kind === 'prompt') {
      hinted.current = true;
      dismiss();
      toast.show(t('pwa.installHint'), 'info', {
        label: t('pwa.install'),
        onClick: () => void install.install(),
      });
    } else if (kind === 'ios') {
      hinted.current = true;
      dismiss();
      toast.show(t('pwa.iosHint'), 'info');
    }
  }, [kind, dismissed, dismiss, install, toast, t]);

  useEffect(() => {
    if (!updateAvailable || updateShown.current) return;
    updateShown.current = true;
    toast.show(t('pwa.updateAvailable'), 'info', {
      label: t('pwa.reload'),
      onClick: () => window.location.reload(),
    });
  }, [updateAvailable, toast, t]);

  return null;
}
